import type { Poll } from '@tunasong/schemas'
import { getNextSlotStart } from './date-slot.js'

/**
 * A rehearsal poll is a many-of-many poll with dated slots — deliberately not a new pollType.
 * `finalOption` on many-of-many is already `Record<string, boolean>`, so N winners are the
 * existing data shape and a single night is simply `datesNeeded: 1`.
 *
 * `allowChange` is on by design: availability changes constantly, and answers are auto-saved
 * and editable until the poll closes.
 */
const template = {
  type: 'poll',
  name: 'Rehearsal poll',
  pollType: 'many-of-many',
  allowChange: true,
  datesNeeded: 1,
  pollOptions: [{ name: '', start: getNextSlotStart() }],
} satisfies Poll

export default template
